import { datesFirstCaps } from "../../constants/dates";

export const getBackgroundColorForStatus = (status) => {
    switch (status) {
        case sdoStatusType.SUBMITTED:
            return "#e99a21";
        case sdoStatusType.DECLINED:
            return "#A42125 ";
        case sdoStatusType.APPROVED:
            return "#108C0C";
        case sdoStatusType.REVOKED:
            return "#737373";
        case sdoStatusType.CONFLICT:
            return "#d75600";
        default:
            return '';
    }
};

export const sdoStatusType = {
    SUBMITTED: "SUBMITTED",
    DECLINED: "DECLINED",
    APPROVED: "APPROVED",
    REVOKED: "REVOKED",
    CONFLICT: "CONFLICT"
};

export enum infoTabStatus {
    approved = 'APPROVED',
    closed = 'CLOSED',
    open = 'OPEN',
    openSoon = 'OPENING SOON',
    overDue = 'OVERDUE'
}

export const requestlistNoData = [
    {
        "id": "1",
        "requested_on": "useSpecialDayOffContext.sdoInfoTabData.sdo_year",
        "requested_from_dt": "-",
        "requestedOn": "-",
        "status": "Not Requested Yet",
    }
]

export const checkConsecutiveDays = (selectedBlockDay) => {
    let isConsecutiveDays = true;
    const datesArray = selectedBlockDay.map(blockDay => new Date(blockDay.dataset.value)).sort((a, b) => a - b);

    datesArray.forEach((date, index, array) => {

        if (index === 0) { return true; }
        let prevDate = array[index - 1];
        let currentDate = new Date(prevDate.setDate(prevDate.getDate() + 1));
        if (date.getDate() !== currentDate.getDate()) {
            isConsecutiveDays = false;
        }
    })
    return isConsecutiveDays;
}


export const getSelectedDays = () => {
    const selectedBlockDay: any = [];
    const calBlockDays: any = document.querySelectorAll('.sdo__calendar__day');    
    if(calBlockDays){
        calBlockDays.forEach(blockDay => {
            if(blockDay && blockDay.classList.contains('sdo__calendar__day--selected')){
                selectedBlockDay.push(blockDay);
            }
        });
    }
    const datesArray = selectedBlockDay.map(blockDay => {
        return new Date(blockDay.dataset.value);
    }).sort((a,b) => a-b);
    return datesArray;
}

export const getTwoDigits = (param) => param < 10 ? ('0' + param) : param;
export const getMonthNday = (date) => {
    if (!date) return '';
    return datesFirstCaps[new Date(date).getMonth()] + " " + getTwoDigits(new Date(date).getDate()) + " ";
}
export const getHourNminute = (date) => {
    if (!date) return '';
    return "@ " + getTwoDigits(new Date(date).getHours()) + ":" + getTwoDigits(new Date(date).getMinutes()) + " ET";
}

export const getBlockedDayCalendarClass = (code) => {
    switch(code){
        case 'Other':
            return 'sdo__calendar__day--other';
        case 'Vacation':
            return 'sdo__calendar__day--vacation';
        case 'SIM': case 'SCHOOL': case 'ART': case 'IOE':
            return 'sdo__calendar__day--training';
        case 'Embargo':
            return 'sdo__calendar__day--embargo';
        case pilotScheduleCodeTypes.PAIRING : 
            return 'sdo__calendar__day--pairings';
        case pilotScheduleCodeTypes.SDO_REQ:
            return 'sdo__calendar__day--sdo_req';
        case pilotScheduleCodeTypes.SDO:
            return 'sdo__calendar__day--sdo';
        case pilotScheduleCodeTypes.GAP: 
            return 'sdo__calendar__day--gap';
        default:
            return 'sdo__calendar__day--other';
    }
}

export const submissionReportStatus = {
    OPEN: "open",
    CLOSED: "closed",
    OVERDUE: "overdue",
};

export const pilotScheduleCodeTypes = {
    PAIRING: 'Pairing',
    OTHER: 'Other',
    EMBARGO : "Embargo",
    SIM: 'SIM',
    ART: "ART",
    SCHOOL: 'SCHOOL',
    IOE: 'IOE',
    VACATION: 'Vacation',
    SDO: 'SDO',
    GAP: 'GAP',
    SDO_REQ: 'SDO Requested'
};

/**
 * Compares two timestamp values to return earlier date first
 * @function 
 * @param {Object} a pilot schedule object
 * @param {Object} b pilot schedule object
 * @returns {Number}
 */
export const sortTimeAsc = (a,b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime();


/**
 * Filters schedules based on schedule type and sort them in ascending timestamp
 * @function  
 * @param {Array} pilotSchedule pilot schedule
 * @param {String} key key to filter
 * @returns {Array} filtered and sorted array of specifc schedule code type
 */
export const filterAndSortTimeAsc = (pilotSchedule, key) => {
    return pilotSchedule?.filter(schedule => key.includes(schedule.code)).sort(sortTimeAsc);
};

/**
 * Changes schedule to bring it within Calendar's range
 * @function  
 * @param {Array} pilotSchedule pilot schedule
 * @param {String} calendarStart start date of calendar
 * @param {String} calendarEnd end date of calendar
 * @returns {Array} updated pilot schedule array
 */
export const checkAndModifyRange = (pilotSchedule, calendarStart, calendarEnd) => {
    let updatedPilotSchedule = pilotSchedule;
    updatedPilotSchedule = calendarStart && calendarEnd && pilotSchedule?.map(sch => {
        if(new Date(sch.start_date+" 00:00").getTime() < new Date(calendarStart+" 00:00").getTime() && 
        new Date(sch.end_date+" 00:00").getTime() >= new Date(calendarStart+" 00:00").getTime() &&
        new Date(sch.end_date+" 00:00").getTime() <= new Date(calendarEnd+" 00:00").getTime()){
            sch.start_date = calendarStart;
        }
        return sch;
    });
    return updatedPilotSchedule || [];
};

/**
 * Checks if start and end date strings are same
 * @function  
 * @param {String} startDate start date string
 * @param {String} endDate end date string
 * @returns {Boolean} true if the dates are same
 */
export const isDateSame = (startDate, endDate) => startDate === endDate;
